import { render, staticRenderFns } from "./YouthSportsLntelligence.vue?vue&type=template&id=c020d8c2&"
import script from "./YouthSportsLntelligence.vue?vue&type=script&lang=js&"
export * from "./YouthSportsLntelligence.vue?vue&type=script&lang=js&"
import style0 from "./YouthSportsLntelligence.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports